import { Button, Modal, Col, Container, Row, Form } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { ModalAlertDetail } from './ModalAlertDetail';
import { useTranslation } from 'react-i18next';
import moment from "moment-timezone";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTriangleExclamation
} from "@fortawesome/free-solid-svg-icons";

import storageService from "../services/storage.service";
import UtilService from "../services/util.service";

import _ from 'lodash';

import { DropdownButtonExport } from "./dropdownButton";

export const ModalEquipmentOverLimit = (props: any) => {

  const user = storageService.getUser();
  const { t } = useTranslation();
  const [endScroll, setEndScroll] = useState(false);
  const scrollElement: React.RefObject<HTMLDivElement> = React.createRef();

  const [modalDetail, setModalDetail] = useState(false);

  const handleCloseModalDetail = () => {
    setModalDetail(false);
  }

  const handleScroll = (e) => {
    const bottom = (e.target.scrollHeight - e.target.scrollTop) < (e.target.clientHeight+5) && (e.target.scrollHeight - e.target.scrollTop) > (e.target.clientHeight-5);
    if (bottom) { 
      setEndScroll(true);
    }
  }

  const renderDate = (value) => {
    if (value) {
      return UtilService.formatDate(moment(value), null);
    }
    return '--';
  };

  const renderDays = (value) => {
    return value ? value : '--';
  };

  useEffect(() => {    
    setEndScroll(scrollElement.current?.scrollHeight == scrollElement.current?.clientHeight);
    
  }, [props.ListAlert, props.Show]);

  return (
    <>
      <Modal backdrop="static" keyboard={ false } as={Modal.Dialog} centered show={props.Show} onHide={props.HandleClose} size='lg'>
        <Modal.Header>
          <Modal.Title className='h6'><FontAwesomeIcon
                title={t('DASHBOARD.EQUIPMENT_LIMIT_BALANCE_ONLINE')}
                style={{ color: 'orange' }}
                icon={faTriangleExclamation}/>&nbsp;&nbsp;{props.Title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p><div dangerouslySetInnerHTML={{__html: t('MODULE_ALERT.MSG_LIMIT_EQUIPMENT_ALERT')}} /></p>
          <Container>
            <Row md={12}
              style={{
                border: 'none',
                background: '#0039A6',
                color: 'white',
                fontWeight: 600,
                textAlign: 'left',
                marginBottom: 1,
                paddingTop: 5,
                paddingBottom: 5

              }} >
              <Col style={{maxWidth: '150px'}}>{t('MODULE_ALERT.GRID_ALERT_DETAIL_CODE_EQUIPMENT')}</Col>
              <Col style={{maxWidth: '150px'}}>{t('MODULE_ALERT.GRID_ALERT_DETAIL_BRANCHNAME')}</Col>
              <Col style={{maxWidth: '200px'}}>{t('MODULE_ALERT.GRID_ALERT_DETAIL_OVER_LIMIT')}</Col>
              <Col md={3}>{t('MODULE_ALERT.GRID_ALERT_DETAIL_DAYS_NO_COLLECTION')}</Col>
            </Row>

            <Row md={12}
                  style={{
                    overflowY: 'auto',
                    maxHeight: '300px'                    
                  }} onScroll={handleScroll} ref = {scrollElement}>
            
            {props.ListAlert?.map(item => {
              return <>

                <Row md={12}
                  style={{
                    border: '1px solid rgb(222 226 230)',
                    borderCollapse: 'collapse',
                    paddingTop: 5,
                    marginTop: -1
                  }}
                  key={item.id_equipment}
                >
                  <Col style={{maxWidth: '150px'}}>{item.code_equipment}</Col>
                  <Col style={{maxWidth: '150px'}}>{item.nickname}</Col>
                  <Col style={{maxWidth: '200px'}}>{renderDate(moment(item.exceeded_balance_deadline).format("YYYY-MM-DD"))}</Col>
                  <Col md={3}>{renderDays(item.days_since_last_collection)} {item.days_since_last_collection && t('MODULE_ALERT.DAYS')}</Col>                  
                </Row>
              </>
            })}
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
            {/*
              Sprint 29
              Botão para fazer a exportação dos dados*/}
            <DropdownButtonExport
              isLoading={false}
              onClick={(type: string) => props.onExportClick(type)}
            />          
          <Button disabled={!endScroll} variant="primary" onClick={props.HandleClose}>{props.ButtonCloseLabel}</Button>          
        </Modal.Footer>
      </Modal>
      {modalDetail &&
        <ModalAlertDetail
          Title={t('MODULE_ALERT.DETAIL')}
          AlertId={0}
          ButtonCloseLabel={`${t('MODULE_ALERT.AWARE')}`}
          HandleClose={handleCloseModalDetail}
          Show={modalDetail}>
        </ModalAlertDetail>
      }
    </>
  );
};
